module.exports = __webpack_public_path__ + "img/nft.f20ee4d8.svg";